const SuppliersIndexPage = (resolve) => {
  require.ensure(["./suppliers/index.vue"], () => {
    resolve(require("./suppliers/index.vue"))
  }, "financial_suppliers")
}

const SupplierFormPage = (resolve) => {
  require.ensure(["./suppliers/form.vue"], () => {
    resolve(require("./suppliers/form.vue"))
  }, "financial_suppliers")
}

const NaturesIndexPage = (resolve) => {
  require.ensure(["./natures/index.vue"], () => {
    resolve(require("./natures/index.vue"))
  }, "financial_natures")
}

const ReceivablesIndexPage = (resolve) => {
  require.ensure(["./receivables/index.vue"], () => {
    resolve(require("./receivables/index.vue"))
  }, "financial_receivables")
}

const ShowReceivablePage = (resolve) => {
  require.ensure(["./receivables/show.vue"], () => {
    resolve(require("./receivables/show.vue"))
  }, "financial_receivables")
}

const ReceivableSettlesPage = (resolve) => {
  require.ensure(["./receivables/settles/settles.vue"], () => {
    resolve(require("./receivables/settles/settles.vue"))
  }, "financial_receivables")
}

const PayablesIndexPage = (resolve) => {
  require.ensure(["./payables/index.vue"], () => {
    resolve(require("./payables/index.vue"))
  }, "financial_payables")
}

const ShowPayablePage = (resolve) => {
  require.ensure(["./payables/show.vue"], () => {
    resolve(require("./payables/show.vue"))
  }, "financial_payables")
}

const PayableSettlesPage = (resolve) => {
  require.ensure(["./payables/settles/settles.vue"], () => {
    resolve(require("./payables/settles/settles.vue"))
  }, "financial_payables")
}

const CertAnticipationsPage = (resolve) => {
  require.ensure(["./cert-anticipations/index.vue"], () => {
    resolve(require("./cert-anticipations/index.vue"))
  }, "financial_cert-anticipations")
}

const DailyCertsPage = (resolve) => {
  require.ensure(["./daily-certs/index.vue"], () => {
    resolve(require("./daily-certs/index.vue"))
  }, "financial_daily-certs")
}

const EmployeeCertsPage = (resolve) => {
  require.ensure(["./employee-certs/index.vue"], () => {
    resolve(require("./employee-certs/index.vue"))
  }, "financial_employee-certs")
}

const PendingCertsPage = (resolve) => {
  require.ensure(["./pending-certs/index.vue"], () => {
    resolve(require("./pending-certs/index.vue"))
  }, "financial_pending-certs")
}

const CustomerInvoicesPage = (resolve) => {
  require.ensure(["./customer-invoices/index.vue"], () => {
    resolve(require("./customer-invoices/index.vue"))
  }, "financial_customer-invoices")
}

const NewCustomerInvoicePage = (resolve) => {
  require.ensure(["./customer-invoices/new/index.vue"], () => {
    resolve(require("./customer-invoices/new/index.vue"))
  }, "financial_customer-invoices")
}

const ShowCustomerInvoicePage = (resolve) => {
  require.ensure(["./customer-invoices/show.vue"], () => {
    resolve(require("./customer-invoices/show.vue"))
  }, "financial_customer-invoices")
}

const EmployeeInvoicesPage = (resolve) => {
  require.ensure(["./employee-invoices/index.vue"], () => {
    resolve(require("./employee-invoices/index.vue"))
  }, "financial_employee-invoices")
}

const NewEmployeeInvoicePage = (resolve) => {
  require.ensure(["./employee-invoices/new/index.vue"], () => {
    resolve(require("./employee-invoices/new/index.vue"))
  }, "financial_employee-invoices")
}

const ShowEmployeeInvoicePage = (resolve) => {
  require.ensure(["./employee-invoices/show.vue"], () => {
    resolve(require("./employee-invoices/show.vue"))
  }, "financial_employee-invoices")
}

export default (appRoutes) => {
  appRoutes.push({ path: "financial/suppliers", component: SuppliersIndexPage })
  appRoutes.push({ path: "financial/suppliers/:id", component: SupplierFormPage })  
  appRoutes.push({ path: "financial/natures", component: NaturesIndexPage })
  appRoutes.push({ path: "financial/receivables", component: ReceivablesIndexPage })
  appRoutes.push({ path: "financial/receivables/:id", component: ShowReceivablePage })
  appRoutes.push({ path: "financial/receivables-settles", component: ReceivableSettlesPage })
  appRoutes.push({ path: "financial/payables", component: PayablesIndexPage })
  appRoutes.push({ path: "financial/payables/:id", component: ShowPayablePage })
  appRoutes.push({ path: "financial/payables-settles", component: PayableSettlesPage })
  appRoutes.push({ path: "financial/daily-certs", component: DailyCertsPage })
  appRoutes.push({ path: "financial/employee-certs", component: EmployeeCertsPage })
  appRoutes.push({ path: "financial/pending-certs", component: PendingCertsPage })
  appRoutes.push({ path: "financial/cert-anticipations", component: CertAnticipationsPage })
  appRoutes.push({ path: "financial/customer-invoices", component: CustomerInvoicesPage })
  appRoutes.push({ path: "financial/customer-invoices/new", component: NewCustomerInvoicePage })
  appRoutes.push({ path: "financial/customer-invoices/:id/show", component: ShowCustomerInvoicePage })
  appRoutes.push({ path: "financial/employee-invoices", component: EmployeeInvoicesPage })
  appRoutes.push({ path: "financial/employee-invoices/new", component: NewEmployeeInvoicePage })
  appRoutes.push({ path: "financial/employee-invoices/:id/show", component: ShowEmployeeInvoicePage })
}